<template>
  <new-catalog-page v-if="newLayout" />
  <catalog-page-with-filters v-else :case-scope="true" />
</template>

<script>
import CatalogPageWithFilters from '~/components/catalog/CatalogPageWithFilters.vue'
import NewCatalogPage from '~/components/new-catalog/NewCatalogPage.vue'
import Cookie from '~/utils/Cookie'

export default {
  name: 'CapinhasParaCelular',
  components: {
    CatalogPageWithFilters,
    NewCatalogPage,
  },
  asyncData({ ...ctx }) {
    const { route } = ctx
    const newLayout =
      ctx.$isBrStore || Cookie.IndependentContext(ctx).get('new_catalog_layout')

    if (newLayout) return { newLayout: true }
    if (route.query.new === '1') {
      const expiresDays = 1
      const date = new Date()
      date.setDate(date.getDate() + expiresDays)

      const cookie = Cookie.Server(ctx).set({
        new_catalog_layout: '1',
        path: '/',
        expires: date,
        domain: ctx.$isBrStore ? '.gocase.com.br' : '.gocase.com',
        HttpOnly: true,
      })

      if (ctx && ctx.res) ctx.res.setHeader('Set-Cookie', cookie)

      return {
        newLayout: true,
      }
    }
  },
}
</script>
